import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const departed_from_appointment = ({ event: { kind, data: { disposition } } }) =>
  <div className={kind}>
    Disposition: {disposition ? disposition.replace(/_/g, ' ') : 'N/A'}
  </div>;

departed_from_appointment.defaultProps = { phase: null };

departed_from_appointment.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      disposition: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/departed_from_appointment.jsx